const trackEvent = (event, data) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, data);
  }
};

export const trackSearchSubmitted = (searchTerm, searchLength) => {
  trackEvent('search_query_submitted', {
    search_term: searchTerm,
    search_length: searchLength,
  });
};

export const trackSearchResultsView = (searchTerm, resultCount, resultTimeMs) => {
  trackEvent('search_results_viewed', {
    search_term: searchTerm,
    result_count: resultCount,
    results_time_ms: resultTimeMs,
  });
};

export const trackSearchClick = (searchTerm, resultPosition, resultUrl) => {
  trackEvent('search_result_clicked', {
    search_term: searchTerm,
    result_position: resultPosition,
    result_url: resultUrl,
  });
};

export const trackNoResults = (searchTerm, searchLength, activeFilters = null) => {
  const eventData = {
    search_term: searchTerm,
    search_length: searchLength,
  };

  if (activeFilters && activeFilters.length > 0) {
    eventData.active_filters = activeFilters;
  }

  trackEvent('no_results_returned', eventData);
};

export const trackFilterApplied = (filterType, filterValue) => {
  trackEvent('search_filter_applied', {
    filter_type: filterType,
    filter_value: filterValue,
  });
};

// New tracking functions for the requested events

/**
 * Track when a user abandons search without interacting with results
 * @param {string} searchTerm - The search term that was abandoned
 * @param {number} timeOnResultsPage - Time spent on results page in milliseconds
 */
export const trackSearchAbandoned = (searchTerm, timeOnResultsPage) => {
  trackEvent('search_abandoned', {
    search_term: searchTerm,
    time_on_results_page: timeOnResultsPage,
  });
};

/**
 * Track search system performance metrics
 * @param {string} searchTerm - The search term that was executed
 * @param {number} latencyMs - Search response time in milliseconds
 */
export const trackSearchLatencyRecorded = (searchTerm, latencyMs) => {
  trackEvent('search_latency_recorded', {
    search_term: searchTerm,
    latency_ms: latencyMs,
  });
};

/**
 * Track user feedback on search results
 * @param {string} sentiment - 'positive' or 'negative'
 * @param {string} searchFeedback - Optional qualitative feedback text
 * @param {string} searchTerm - The search term that received feedback
 */
export const trackFeedbackSubmitted = (sentiment, searchFeedback = null, searchTerm = null) => {
  const eventData = {
    sentiment: sentiment,
  };

  if (searchFeedback) {
    eventData.search_feedback = searchFeedback;
  }

  if (searchTerm) {
    eventData.search_term = searchTerm;
  }

  trackEvent('feedback_submitted', eventData);
};
